// Fix for empty page on booking page
document.addEventListener('DOMContentLoaded', () => {
  const anchor = window.location.hash;
  if (anchor === '') {
    /* eslint-disable-next-line no-undef, camelcase */
    window.location.href = azds_booking.first_step;
  }
});
